import { wordService } from "../services/wordService";

export const applyHeading6 = () =>
  wordService.applySemanticTag({ type: "section", styleBuiltIn: "Heading6", metadata: { level: 6 } });
